import React, { memo } from 'react';
export const ProblemSection = memo(function ProblemSection() {
  const problems = [{
    icon: '💸',
    text: 'Pagás técnicos que cobran el doble de lo que ganás en un día por arreglos que llevan 20 minutos.'
  }, {
    icon: '📉',
    text: 'Tu sueldo no te alcanza ni para cubrir lo básico y cada mes terminás más ajustado que el anterior.'
  }, {
    icon: '😤',
    text: 'Sabés que hay gente ganando bien con un oficio, pero nunca tuviste quién te enseñara por dónde empezar.'
  }, {
    icon: '⏳',
    text: 'Esperás días un técnico que llega tarde, cobra caro y encima te hace sentir que no sabés nada.'
  }];
  return <section className="py-12 px-4 bg-gray-50 border-t border-gray-200" data-id="element-157">
      <div className="max-w-2xl mx-auto" data-id="element-158">
        {/* PROBLEMA */}
        <h2 className="text-[22px] md:text-3xl font-black text-gray-900 leading-tight text-center mb-6" data-id="element-159">
          La realidad que nadie dice en voz alta{' '}
          <span className="text-blue-600" data-id="element-160">pero todos vivimos.</span>
        </h2>

        <div className="space-y-3 mb-6" data-id="element-161">
          {problems.map((p, i) => <div key={i} className="flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 shadow-sm" data-id="element-162">
              <span className="text-2xl flex-shrink-0" data-id="element-163">{p.icon}</span>
              <p className="text-gray-900 font-bold text-[14px] md:text-base leading-snug" data-id="element-164">
                {p.text}
              </p>
            </div>)}
        </div>

        {/* PUENTE + SOLUCIÓN */}
        <div className="bg-blue-50 border border-blue-200 rounded-xl px-5 py-6 text-center shadow-sm" data-id="element-165">
          <div className="inline-block px-4 py-1 rounded-full font-bold text-xs mb-3 text-blue-600 bg-blue-100 border border-blue-200 uppercase tracking-widest" data-id="element-166">
            ⚡ La Solución
          </div>
          <h3 className="text-[20px] md:text-3xl font-black text-blue-600 mb-2" data-id="element-167">
            MEGAPACK ELECTRICISTA
          </h3>
          <p className="text-gray-700 font-bold text-[13px] md:text-base leading-snug mb-4" data-id="element-168">
            El sistema completo para dominar la electricidad desde cero. Resolvé
            los problemas de tu casa hoy y convertite en profesional para
            generar ingresos reales mañana.
          </p>
          <div className="grid grid-cols-2 gap-2" data-id="element-169">
            {[{
            icon: '📚',
            text: '6 Tomos de Cero a Profesional'
          }, {
            icon: '🔧',
            text: 'Sin conocimientos previos'
          }, {
            icon: '💰',
            text: 'Generá ingresos desde el día 1'
          }, {
            icon: '🛡️',
            text: 'Con protocolos de seguridad real'
          }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-3 py-2 shadow-sm" data-id="element-170">
                <span className="text-lg" data-id="element-171">{item.icon}</span>
                <p className="text-gray-900 font-bold md:text-sm text-[10px]" data-id="element-172">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
});